import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Partialproductquote } from '../../../../../model/partialproductquote';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../../store/state/app.state';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
@Component({
  selector: 'app-partial-product-quote',
  templateUrl: './partial-product-quote.component.html',
  styleUrls: ['./partial-product-quote.component.scss']
})
export class PartialProductQuoteComponent implements OnInit {
  @Input() Partialproductquote: Partialproductquote;
  @Input() isDocumentRequired = true;
  @Input() iterationId = 1;
  public contentData;
  protected cmsDataYourSavedQuotes;
  public cmsDataProductQuote;
  protected cmsDataHeaderData;
  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private store: Store<AppState>) {
this.contentData = this.activatedRoute.snapshot.data.contentData.youroptionscalculations;
this.cmsDataProductQuote = this.activatedRoute.snapshot.data.contentData.productQuote;
this.cmsDataHeaderData = this.activatedRoute.snapshot.data.contentData.headerData;


    }

  ngOnInit() {
  }
  getInteger(numberwithdecimal) {
    const integerString = String(numberwithdecimal);
    return integerString.split('.')[0];
  }

  getFraction(numberwithdecimal) {
    let decimalString = String(numberwithdecimal);
    decimalString = (decimalString && decimalString.indexOf('.') > -1) ? decimalString.split('.')[1] : '';
    return decimalString.length === 1 ? decimalString + 0 : decimalString.length > 0  ? decimalString : '00';
  }
}
